module.exports = __webpack_public_path__ + "static/media/terrace1-min.b8cc047b.jpg";